exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("./../../../src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-contact-js": () => import("./../../../src/pages/contact.js" /* webpackChunkName: "component---src-pages-contact-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-serve-js": () => import("./../../../src/pages/serve.js" /* webpackChunkName: "component---src-pages-serve-js" */),
  "component---src-pages-supporters-js": () => import("./../../../src/pages/supporters.js" /* webpackChunkName: "component---src-pages-supporters-js" */)
}

